import { ChevronRight, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export const PersonRow = ({ person, badge, onOpen, onDelete }) => (
  <div className="flex items-center gap-3 bg-white border rounded-xl p-3 hover:border-pink-300 transition-colors" data-testid={`person-row-${person.id}`}>
    <button className="flex-1 text-left" onClick={onOpen} data-testid={`person-open-${person.id}`}>
      <p className="font-semibold">{person.last_name.toUpperCase()} {person.first_name}</p>
      <p className="text-xs text-slate-500">{person.email}</p>
    </button>
    {badge}
    <Button variant="ghost" size="icon" className="text-red-500" onClick={onDelete} data-testid={`person-delete-${person.id}`}><Trash2 className="w-4 h-4" /></Button>
    <ChevronRight className="w-5 h-5 text-slate-400" />
  </div>
);
